import Enum from './enum'

class ReportType extends Enum
{
  constructor(value) {
    super(value);
  }
}

ReportType.init({
  PROCEDURES_BY_STAGE: 'stepSummary',
  ECONOMY: 'economy',
  ACCEPTANCE_PRICE: 'price',
  SUMMARY_REGISTRY: 'summary',
  TMC: 'nomen'
}, {
  PROCEDURES_BY_STAGE: 'report-type.procedures-by-stage',
  ECONOMY: 'report-type.economy',
  ACCEPTANCE_PRICE: 'report-type.acceptance-price',
  SUMMARY_REGISTRY: 'report-type.summary-registry',
  TMC: 'report-type.tmc'
});

export default ReportType;
